import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bookmark-sharp",
  "use": "icon-bookmark-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-bookmark-sharp\"><title>Bookmark</title><path d=\"M416 480L256 357.41 96 480V32h320z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol